import React from 'react';
import { Box, useTheme } from '@mui/material';
import Sidebar from './Sidebar/Sidebar';
import Header from './Header/Header';

interface LayoutProps {
  children: React.ReactNode;
  onLogout: () => void;
}

const Layout: React.FC<LayoutProps> = ({ children, onLogout }) => {
  const theme = useTheme();

  const drawerWidth = 280;

  return (
    <Box sx={{ display: 'flex', width: '100%', height: '100vh' }}>
      <Header drawerWidth={drawerWidth} onLogout={onLogout} />
      <Sidebar drawerWidth={drawerWidth} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          // Убираем лишний отступ и перерасчёт ширины – flex-layout сам выделит место
          mt: { xs: '56px', sm: '64px' },
          p: 3,
          backgroundColor: theme.palette.background.default,
          // Фиксируем высоту области контента и включаем собственный скролл,
          // чтобы внешние стили модулей не блокировали прокрутку страницы
          height: { xs: 'calc(100vh - 56px)', sm: 'calc(100vh - 64px)' },
          overflowY: 'auto',
          overflowX: 'hidden',
          minHeight: 0,                // рекомендовано
          overscrollBehaviorY: 'contain', // опционально
          borderTopLeftRadius: '8px',
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default Layout;